export default "__VITE_ASSET__eb6b41bb__"